module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom8.7aedc59e.jpg";